"use client";

import { useEffect, useState } from "react";

/**
 * Catastrophic fallback (replaces the whole document, even the root layout).
 * Self-contained styling because the layout/CSS may not be available here.
 * Locale detection from navigator.language (cannot use LocaleProvider — root failed).
 */
export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const msg = error?.message || "";
  const isSkew = /Failed to find Server Action|older or newer deployment|Connection closed|deployment/i.test(msg);

  // Detect locale from browser (English-leaning fallback)
  const [isEn, setIsEn] = useState(true);
  useEffect(() => {
    if (typeof navigator !== "undefined") {
      setIsEn(!navigator.language.toLowerCase().startsWith("sk"));
    }
  }, []);

  useEffect(() => {
    if (isSkew) {
      const t = setTimeout(() => window.location.reload(), 1400);
      return () => clearTimeout(t);
    }
  }, [isSkew]);

  const txt = isEn
    ? {
        updated: "App was updated",
        loading: "Loading the latest version…",
        generic: "Something went wrong",
        retry: "Please try again or reload the page.",
        reload: "Reload",
      }
    : {
        updated: "Aplikácia bola aktualizovaná",
        loading: "Načítavam najnovšiu verziu…",
        generic: "Niečo sa pokazilo",
        retry: "Skús to prosím znova alebo obnov stránku.",
        reload: "Načítať znova",
      };

  return (
    <html lang={isEn ? "en" : "sk"}>
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f5f6fb",
          color: "#16182b",
          fontFamily: "'Google Sans Flex', Inter, system-ui, -apple-system, sans-serif",
          WebkitFontSmoothing: "antialiased",
        }}
      >
        <div style={{ maxWidth: 420, padding: 24, textAlign: "center" }}>
          <div
            style={{
              width: 56,
              height: 56,
              margin: "0 auto 20px",
              display: "grid",
              placeItems: "center",
              borderRadius: 18,
              background: "rgba(66,10,249,0.10)",
              color: "#420af9",
              fontSize: 28,
            }}
          >
            ⟳
          </div>
          <h1 style={{ fontSize: 20, fontWeight: 700, letterSpacing: "-0.01em", margin: "0 0 8px" }}>
            {isSkew ? txt.updated : txt.generic}
          </h1>
          <p style={{ fontSize: 14, lineHeight: 1.5, color: "#5b5e74", margin: "0 0 22px" }}>
            {isSkew ? txt.loading : txt.retry}
          </p>
          <button
            onClick={() => (isSkew ? window.location.reload() : reset())}
            style={{
              background: "#420af9",
              color: "#fff",
              border: 0,
              borderRadius: 12,
              padding: "11px 20px",
              fontSize: 14,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            {txt.reload}
          </button>
        </div>
      </body>
    </html>
  );
}
